import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material';

import ReactDOM from 'react-dom/client';

import './index.css';
import 'react-toastify/dist/ReactToastify.css';

import { AuthenticationContext } from 'authentication/authentication-context';
import AppRoutes from 'routes';
import { NetworkContext } from 'services/network-context';
import colors from 'theme/colors';
import { StyledToastContainer } from 'design-system-components/ToastifyContainer/styled-toast-container';

const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme({
  palette: {
    primary: {
      main: colors.PRIMARY,
      dark: colors.PRIMARY_DARK,
      contrastText: '#fff',
    },
    action: {
      disabledBackground: colors.PRIMARY_LIGHT,
      disabled: '#FFFFFF',
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '1rem',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 4px 4px 0px rgba(217, 217, 217, 0.25)',
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: 'red',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          padding: '0 !important',
        },
      },
    },
  },
});

root.render(
  <React.StrictMode>
    <NetworkContext>
      <ThemeProvider theme={theme}>
        <AuthenticationContext>
          <AppRoutes />
          <StyledToastContainer position="bottom-center" />
        </AuthenticationContext>
      </ThemeProvider>
    </NetworkContext>
  </React.StrictMode>
);
